export const loadFeaturesRequest = () => ({
    type: 'LOAD_FEATURES_REQUEST',
});

export const loadFeaturesSuccess = features => ({
    type: 'LOAD_FEATURES_SUCCESS',
    payload: features,
});

export const loadFeaturesFailure = error => ({
    type: 'LOAD_FEATURES_FAILURE',
    error: error,
});

export const resetFeatures = () => ({
    type: 'RESET_FEATURES',
});

export const refreshFeaturesRequest = () => ({
    type: 'REFRESH_FEATURES_REQUEST',
});

export const clearFeaturesCache = () => ({
    type: 'CLEAR_FEATURES_CACHE',
});
